


























import { Vue, Component } from 'vue-property-decorator'
import store from 'src/assets/store'
import TopMenu from 'src/components/presenter/layout/TopMenu.vue'
import ActivityDashboard from 'components/presenter/layout/ActivityDashboard.vue'
import api from 'src/assets/api/gql'
import ActivityDashboardQuery from 'src/graphql/person/ActivityDashboard.gql'
import { Session, ForumTopic } from 'src/graphql/types'

@Component({
  components: {
    TopMenu,
    ActivityDashboard
  }
})
export default class LayoutsPresenter extends Vue {
  top = true
  rightDrawerShowing = false

  created () {
    store.setProfile('PRESENTER')
  }

  async activityLoad () {
    const { data: { sessionsRecent: { nodes: sessions }, forumTopicsRecent: { nodes: forumTopics } } } = await api.query({
      query: ActivityDashboardQuery,
      variables: { timezone: Intl.DateTimeFormat().resolvedOptions().timeZone }
    })
    return { sessions, forumTopics }
  }

  activitySessionUrl (session: Session) {
    return `/presenter/session/${session.id}`
  }

  activityForumTopicUrl (forumTopic: ForumTopic) {
    return `/presenter/${forumTopic.courseId}/forum/${forumTopic.id}`
  }
}
